import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import { collection, getDocs, addDoc, query, where, doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { GrDocumentTxt } from "react-icons/gr";
import { toast } from 'react-toastify';

export default function Report() {
  const [cidade, setCidade] = useState([]);
  const [igreja, setIgreja] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [igrejaSelecionada, setIgrejaSelecionada] = useState('');
  const [cargoSelecionado, setCargoSelecionado] = useState('');
  const [generoSelecionado, setGeneroSelecionado] = useState('');
  const [nomeRelatorio, setNomeRelatorio] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [numAtriu, setNumAtriu] = useState(0);
  const [numCorredor, setNumCorredor] = useState(0);
  const [numBanheiro, setNumBanheiro] = useState(0);
  const [numEstacionamento, setNumEstacionamento] = useState(0);
  const [numSom, setNumSom] = useState(0);
  const [cargoTipo, setCargoTipo] = useState(null);
  const [atriu, setAtriu] = useState('');
  const [corredor, setCorredor] = useState('');
  const [banheiro, setBanheiro] = useState('');
  const [estacionamento, setEstacionamento] = useState('');
  const [gerarVazio, setGerarVazio] = useState(false);
  const [som, setSom] = useState('');

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const getDataFromDatabase = async () => {
      try {
        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeData = cidadeSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCidade(cidadeData);

        const igrejaSnapshot = await getDocs(collection(db, 'Igreja'));
        const igrejaData = igrejaSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setIgreja(igrejaData);

        const cargoSnapshot = await getDocs(collection(db, 'Cargo'));
        const cargoData = cargoSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCargos(cargoData);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    getDataFromDatabase();
  }, []);

  const handleGenerateReportP = async (e) => {
    e.preventDefault();

    try {
      const atriuCount = parseInt(numAtriu, 10);
      const corredorCount = parseInt(numCorredor, 10);
      const banheiroCount = parseInt(numBanheiro, 10);
      const estacionamentoCount = parseInt(numEstacionamento, 10);

      if (isNaN(atriuCount) || isNaN(corredorCount) || isNaN(banheiroCount) || isNaN(estacionamentoCount)) {
        toast.error('Certifique-se de preencher todos os campos numéricos corretamente!');
        return;
      }

      if (!nomeRelatorio) {
        toast.error('Por favor, insira o nome do relatório!');
        return;
      }

      const usersQuery = query(
        collection(db, 'User'),
        where('igreja', '==', igrejaSelecionada),
        where('cargo', '==', cargoSelecionado),
        where('genero', '==', generoSelecionado)
      );
      const usersSnapshot = await getDocs(usersQuery);
      const users = usersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      const totalRequired = atriuCount + corredorCount + banheiroCount + estacionamentoCount;

      if (users.length < totalRequired) {
        toast.error('Não há usuários suficientes para preencher todas as funções!');
        return;
      }

      const igrejaDoc = await getDoc(doc(db, 'Igreja', igrejaSelecionada));
      const igrejaData = igrejaDoc.data();
      const diasCulto = igrejaData.diasCulto || [];
      const diasRDJ = igrejaData.diasRDJ || [];

      // Combinar os dias de culto e RDJ
      const serviceDays = [...diasCulto, ...diasRDJ];
      const serviceDates = getServiceDates(startDate, endDate, serviceDays);

      if (serviceDates.length === 0) {
        toast.error('Nenhuma data de culto encontrada. Verifique as configurações de datas.');
        return;
      }
      const weeks = {};
      serviceDates.forEach((date) => {
        const weekStart = getMonday(new Date(date));
        const weekKey = weekStart.toISOString().split('T')[0];
        if (!weeks[weekKey]) weeks[weekKey] = [];
        weeks[weekKey].push(date);
      });

      const report = [];
      const usedUsers = new Set();

      Object.entries(weeks).forEach(([weekStart, weekDates]) => {
        let availableUsers = users.filter((user) => !usedUsers.has(user.id));

        if (availableUsers.length < totalRequired) {
          usedUsers.clear();
          availableUsers = users;
        }

        const weeklyGroup = availableUsers
          .sort(() => Math.random() - 0.5)
          .slice(0, totalRequired);

        weeklyGroup.forEach((user) => usedUsers.add(user.id));

        weekDates.forEach((date) => {
          const shuffledGroup = [...weeklyGroup].sort(() => 0.5 - Math.random());
          const atriu = shuffledGroup.slice(0, atriuCount);
          const corredor = shuffledGroup.slice(atriuCount, atriuCount + corredorCount);
          const banheiro = shuffledGroup.slice(atriuCount + corredorCount, atriuCount + corredorCount + banheiroCount);
          const estacionamento = shuffledGroup.slice(atriuCount + corredorCount + banheiroCount, totalRequired);



          if (gerarVazio) {
            // Cria arrays vazios com o número correto de posições
            const emptyAtriu = Array(atriuCount).fill({ id: '', name: '' });
            const emptyCorredor = Array(corredorCount).fill({ id: '', name: '' });
            const emptyBanheiro = Array(banheiroCount).fill({ id: '', name: '' });
            const emptyEstacionamento = Array(estacionamentoCount).fill({ id: '', name: '' });
          
            report.push({
              date: date.toISOString(),
              atriu: emptyAtriu,
              corredor: emptyCorredor,
              banheiro: emptyBanheiro,
              estacionamento: emptyEstacionamento,
            });
          } else {
            report.push({
              date: date.toISOString(),
              atriu,
              corredor,
              banheiro,
              estacionamento,
            });
          }
        });



      });

      if (report.length === 0) {
        toast.error('Nenhuma data de culto encontrada. Verifique as configurações de datas.');
        return;
      }

      await addDoc(collection(db, 'Reports'), {
        nomeRelatorio,
        cidade: cidadeSelecionada,
        igreja: igrejaSelecionada,
        cargo: cargoSelecionado,
        genero: generoSelecionado,
        report,
        ativo: false,
        createdAt: new Date(),
        createdBy: user.uid,
      });

      toast.success('Relatório gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      toast.error('Erro ao gerar relatório. Tente novamente.');
    }
  };

  const handleGenerateReportS = async (e) => {
    e.preventDefault();

    try {
      const somCount = parseInt(numSom, 10);

      if (isNaN(somCount)) {
        toast.error('Certifique-se de preencher todos os campos numéricos corretamente!');
        return;
      }

      if (!nomeRelatorio) {
        toast.error('Por favor, insira o nome do relatório!');
        return;
      }

      const usersQuery = query(
        collection(db, 'User'),
        where('igreja', '==', igrejaSelecionada),
        where('cargo', '==', cargoSelecionado),
        where('genero', '==', generoSelecionado)
      );
      const usersSnapshot = await getDocs(usersQuery);
      const users = usersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      const totalRequired = somCount;

      if (users.length < totalRequired) {
        toast.error('Não há usuários suficientes para preencher todas as funções!');
        return;
      }

      const igrejaDoc = await getDoc(doc(db, 'Igreja', igrejaSelecionada));
      const igrejaData = igrejaDoc.data();
      const diasCulto = igrejaData.diasCulto || [];
      const diasRDJ = igrejaData.diasRDJ || [];

      // Combinar os dias de culto e RDJ
      const serviceDays = [...diasCulto, ...diasRDJ];
      const serviceDates = getServiceDates(startDate, endDate, serviceDays);

      if (serviceDates.length === 0) {
        toast.error('Nenhuma data de culto encontrada. Verifique as configurações de datas.');
        return;
      }


      const weeks = {};
      serviceDates.forEach((date) => {
        const weekStart = getMonday(new Date(date));
        const weekKey = weekStart.toISOString().split('T')[0];
        if (!weeks[weekKey]) weeks[weekKey] = [];
        weeks[weekKey].push(date);
      });

      const report = [];
      const usedUsers = new Set();

      Object.entries(weeks).forEach(([weekStart, weekDates]) => {
        let availableUsers = users.filter((user) => !usedUsers.has(user.id));

        if (availableUsers.length < totalRequired) {
          usedUsers.clear();
          availableUsers = users;
        }

        const weeklyGroup = availableUsers
          .sort(() => Math.random() - 0.5)
          .slice(0, totalRequired);

        weeklyGroup.forEach((user) => usedUsers.add(user.id));

        weekDates.forEach((date) => {
          const shuffledGroup = [...weeklyGroup].sort(() => 0.5 - Math.random());
          const som = shuffledGroup.slice(0, somCount, totalRequired);



          if (gerarVazio) {
            // Cria array vazio com o número correto de posições
            const emptySom = Array(somCount).fill({ id: '', name: '' });
          
            report.push({
              date: date.toISOString(),
              som: emptySom
            });
          } else {
            report.push({
              date: date.toISOString(),
              som
            });
          }
        });



      });

      if (report.length === 0) {
        toast.error('Nenhuma data de culto encontrada. Verifique as configurações de datas.');
        return;
      }

      await addDoc(collection(db, 'Reports'), {
        nomeRelatorio,
        cidade: cidadeSelecionada,
        igreja: igrejaSelecionada,
        cargo: cargoSelecionado,
        genero: generoSelecionado,
        report,
        ativo: false,
        createdAt: new Date(),
        createdBy: user.uid,
      });

      toast.success('Relatório gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      toast.error('Erro ao gerar relatório. Tente novamente.');
    }
  };

  function getMonday(date) {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
  }

  function getServiceDates(start, end, serviceDays) {
    const dayMap = {
      'Domingo': 0,
      'Segunda': 1,
      'Terca': 2,
      'Quarta': 3,
      'Quinta': 4,
      'Sexta': 5,
      'Sabado': 6
    };

    const dates = [];
    let currentDate = new Date(`${start}T00:00:00`);
    const endDateObj = new Date(`${end}T23:59:59`);

    while (currentDate <= endDateObj) {
      const dayOfWeek = currentDate.getDay();
      const dayOfWeekString = Object.keys(dayMap).find(key => dayMap[key] === dayOfWeek);

      const matchingServiceDays = serviceDays.filter(serviceDay => serviceDay.dia === dayOfWeekString);

      matchingServiceDays.forEach(serviceDay => {
        const [hour, minute] = serviceDay.horario.split(':').map(Number);
        const serviceDateTime = new Date(currentDate);
        serviceDateTime.setHours(hour, minute, 0, 0);
        dates.push(new Date(serviceDateTime.getTime() - serviceDateTime.getTimezoneOffset() * 60000));
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }


    return dates;
  }

  const handleCargoChange = async (e) => {
    const selectedCargoId = e.target.value;
    setCargoSelecionado(selectedCargoId);

    if (selectedCargoId) {
      try {
        const cargoRef = doc(db, 'Cargo', selectedCargoId);
        const cargoDoc = await getDoc(cargoRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();
          setCargoTipo(cargoData.tipo);
        } else {
          setCargoTipo(null);
        }

        // Buscar dados da Igreja (atriu, corredor, banheiro, estacionamento, som)
        if (igrejaSelecionada) {
          const igrejaRef = doc(db, 'Igreja', igrejaSelecionada);
          const igrejaDoc = await getDoc(igrejaRef);

          
        }
      } catch (error) {
        console.error('Erro ao buscar o tipo do cargo ou dados da igreja:', error);
      }
    }
  };

  useEffect(() => {
    const fetchIgrejaDetails = async () => {
      if (igrejaSelecionada) {
        try {
          const igrejaRef = doc(db, 'Igreja', igrejaSelecionada);
          const igrejaDoc = await getDoc(igrejaRef);

          if (igrejaDoc.exists()) {
            const igrejaData = igrejaDoc.data();
            // Atualizando os estados com os valores recebidos do Firestore
            setAtriu(igrejaData.atriu || '0');
            setCorredor(igrejaData.corredor || '0');
            setBanheiro(igrejaData.banheiro || '0');
            setEstacionamento(igrejaData.estacionamento || '0');
            setSom(igrejaData.som || '0');
          }
        } catch (error) {
          console.error('Erro ao buscar dados da igreja:', error);
        }
      }
    };

    fetchIgrejaDetails();
  }, [igrejaSelecionada]);






  return (
    <div>
      <Header />
      <div className="content">
        <Title name="Relatório">
          <GrDocumentTxt size={25} />
        </Title>
        <div className="container">
          <form onSubmit={cargoTipo === "UserP" ? handleGenerateReportP : handleGenerateReportS}>
            <label style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
              <input
                type="checkbox"
                checked={gerarVazio}
                onChange={(e) => setGerarVazio(e.target.checked)}
                style={{ marginRight: '10px' }}
              />
              Gerar relatório apenas com datas (sem usuários pré-definidos)
            </label>
            <label>Nome do Relatório</label>
            <input
              type="text"
              placeholder="Digite o nome do relatório"
              value={nomeRelatorio}
              onChange={(e) => setNomeRelatorio(e.target.value)}
            />

            <label>Cidade</label>
            <select
              value={cidadeSelecionada}
              onChange={(e) => setCidadeSelecionada(e.target.value)}
            >
              <option value="">Selecione uma cidade</option>
              {cidade.map((cidade) => (
                <option key={cidade.id} value={cidade.id}>
                  {cidade.nome}
                </option>
              ))}
            </select>

            <label>Casa de Oração</label>
            <select
              value={igrejaSelecionada}
              onChange={(e) => setIgrejaSelecionada(e.target.value)}
            >
              <option value="">Selecione uma Casa de Oração</option>
              {igreja.map((igreja) => (
                <option key={igreja.id} value={igreja.id}>
                  {igreja.nome}
                </option>
              ))}
            </select>

            <label>Gênero</label>
            <select
              value={generoSelecionado}
              onChange={(e) => setGeneroSelecionado(e.target.value)}
            >
              <option value="">Selecione um gênero</option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
            </select>

            <label>Data Início</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

            <label>Data Fim</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

            <label>Cargo</label>
            <select
              value={cargoSelecionado}
              onChange={handleCargoChange}
            >
              <option value="">Selecione um cargo</option>
              {cargos.map((cargo) => (
                <option key={cargo.id} value={cargo.id}>
                  {cargo.nome}
                </option>
              ))}
            </select>

            {cargoTipo === 'UserP' && (
              <>
                <label>Quantidade no {atriu}</label>
                <input
                  type="number"
                  value={numAtriu}
                  onChange={(e) => setNumAtriu(e.target.value)}
                />

                <label>Quantidade no {corredor} </label>
                <input
                  type="number"
                  value={numCorredor}
                  onChange={(e) => setNumCorredor(e.target.value)}
                />

                <label>Quantidade no {banheiro}</label>
                <input
                  type="number"
                  value={numBanheiro}
                  onChange={(e) => setNumBanheiro(e.target.value)}
                />

                <label>Quantidade no {estacionamento}</label>
                <input
                  type="number"
                  value={numEstacionamento}
                  onChange={(e) => setNumEstacionamento(e.target.value)}
                />
              </>
            )}

            {cargoTipo === 'UserS' && (
              <>
                <label>Quantidade no {som}</label>
                <input
                  type="number"
                  value={numSom}
                  onChange={(e) => setNumSom(e.target.value)}
                />
              </>
            )}

            {cargoTipo === 'Admin' && (
              <p style={{ color: 'red' }}>
                Cargos Admin não podem gerar relatórios.
              </p>
            )}

            {cargoTipo !== 'Admin' && cargoTipo && (
              <button type="submit">Gerar Relatório</button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
